import React, { useContext, useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
import { usePanelStyles, ModalTitle, TableCard, RowActions } from "../FormFields/panel";

const handleRemoveContactTag = async (contactId, tagId) => {
  await api.delete(`/tags-contacts/${tagId}/${contactId}`);
}

const ContactTagListModal = ({ open, onClose, tag }) => {
  const p = usePanelStyles();
  const [tagList, setTagList] = useState(tag.contacts);
  const { user, socket } = useContext(AuthContext);

  useEffect(() => {
    console.log("tagList", tagList)
  }, [tagList])

  useEffect(() => {
    // const socket = socketManager.GetSocket(user.companyId, user.id);

    const onCompanyTags = (data) => {
      if (data.action === "update" || data.action === "create") {
        if (data.tag.id === tag.id && data.tag?.contacts?.length > 0) {
          setTagList(data.tag.contacts);
        }
        if (data.tag.id === tag.id && data.tag?.contacts?.length === 0) {
          setTagList([]);
          onClose();
        }
      }
    };
    socket.on(`company${user.companyId}-tag`, onCompanyTags);

    return () => {
      socket.off(`company${user.companyId}-tag`, onCompanyTags);
    };
  }, []); // Dependência do estado auxiliar updateFlag

  return tagList.length > 0 ? (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      scroll="paper"
      aria-labelledby="transition-modal-title"
      classes={{ paper: p.dialogPaper }}
    >
      <ModalTitle
        id="transition-modal-title"
        title={`${tag.name} - Contatos`}
        subtitle="Contatos com esta tag. Remover apenas tira a tag do contato."
        onClose={onClose}
      />
      <DialogContent className={p.modalBody}>
        <TableCard>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Nome</TableCell>
                <TableCell>Número</TableCell>
                <TableCell align="right">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tagList?.map((contact) => (
                <TableRow key={contact.id}>
                  <TableCell className={p.cellMuted}>{contact.id}</TableCell>
                  <TableCell className={p.cellStrong}>{contact.name}</TableCell>
                  <TableCell>{contact.number}</TableCell>
                  <TableCell align="right">
                    <RowActions>
                      <Tooltip title="Remover tag do contato">
                        <IconButton
                          aria-label="Remover tag do contato"
                          onClick={() => handleRemoveContactTag(contact.id, tag.id)}
                        >
                          <DeleteOutlineIcon />
                        </IconButton>
                      </Tooltip>
                    </RowActions>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableCard>
      </DialogContent>
    </Dialog>
  ) : (
    <></>
  )
};

export default ContactTagListModal;
